export const eramCursorCenterMap = {
    ERAMCursor1: [4, 4],
    ERAMCursor2: [7, 7],
    ERAMCursor3: [9, 9],
    ERAMCursor4: [11, 11],
    ERAMCursor5: [13, 13],
    ERAMDeletionCursor: [7, 7],
    ERAMDrawCursor: [7, 7],
    ERAMInvalidSelectionE: [14, 14],
    ERAMInvalidSelectionI: [14, 14],
    ERAMInvalidSelectionP: [14, 14],
    ERAMInvalidSelectionX: [14, 14],
};
//# sourceMappingURL=eramCursor.js.map